import { render } from "./Steps5.vue?vue&type=template&id=5ecad7ef"
import script from "./Steps5.vue?vue&type=script&lang=js"
export * from "./Steps5.vue?vue&type=script&lang=js"
script.render = render

export default script